import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { Grid } from '@mui/material';
import AssignmentListItem from '../AssignmentListItem/AssignmentListItem';
import AssignmentListEmptyState from '../AssignmentListItem/AssignmentListEmptyState';
import { isAssignmentVisible } from '../../../utils/assignmentVisibilityHelpers';

const UpcomingAssignmentList = ({ assignments, toggleAssignmentView }) => {
    const { ltoeWebAssignmentsPreBooking } = useFlags();

    const filteredAssignments = assignments
        ? assignments.filter((assignment) =>
              isAssignmentVisible(assignment, ltoeWebAssignmentsPreBooking)
          )
        : [];

    const renderAssignments = () => {
        if (filteredAssignments.length === 0) {
            return (
                <div style={{ width: '100%' }}>
                    <AssignmentListEmptyState assignmentType="upcoming" />
                </div>
            );
        }
        return (
            <Grid container>
                {filteredAssignments.map((item) => (
                    <AssignmentListItem
                        type="upcoming"
                        key={item.name}
                        assignment={item}
                        toggleAssignmentView={toggleAssignmentView}
                    />
                ))}
            </Grid>
        );
    };

    return (
        <div>
            <Grid container>{renderAssignments()}</Grid>
        </div>
    );
};

export default UpcomingAssignmentList;
